import { UserModel } from './'
export class ProjectModel {
    constructor(
        public project_id?: string,
        public project_name?: string,
        public project_description?: string,
        public project_scrum_time?: string,
        public project_start_date?: string,
        public project_end_date?: string,
        public project_status?: string,
        public project_members?: [UserModel]
    ) { }

    // getProjectDetailUrl(){
    //     return ""+ this.id
    // }
}


// WEBPACK FOOTER //
// ./src/app/modules/models/project-model.ts